import { writable } from 'svelte/store';

export const newLiveChannel = writable(null);

export function setNewLiveChannel(channel: any) {
  newLiveChannel.set(channel);
  setTimeout(() => {
    newLiveChannel.set(null);
  }, 5000);
}